export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/invitation_design.5fcde0c.svg";